var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "kickoff-tab" }, [
    _vm.formData.project_type === "1"
      ? _c(
          "div",
          {
            staticClass: "sub-form-container",
            class: { "sub-form-editing": _vm.isEditingTask("projectInfo") },
          },
          [
            _c("div", { staticClass: "sub-form-title" }, [_vm._v("项目信息")]),
            _c(
              "div",
              [
                _c("div", { staticClass: "small-form-title" }, [
                  _vm._v("项目基本信息"),
                ]),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "项目情况",
                              prop: "project_evaluation.project_basic_info",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                readonly: _vm.isViewTaskDisabled("projectInfo"),
                                rows: 4,
                                placeholder:
                                  "客户基本信息/核心需求/痛点，请详细描述",
                                maxlength: 2000,
                                "show-word-limit": "",
                              },
                              model: {
                                value:
                                  _vm.formData.project_evaluation
                                    .project_basic_info,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.project_evaluation,
                                    "project_basic_info",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.project_evaluation.project_basic_info",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "是否投标",
                              prop: "project_evaluation.is_bidding",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: {
                                  disabled:
                                    _vm.isProjectInfoFieldDisabled(
                                      "is_bidding"
                                    ),
                                },
                                on: { change: _vm.changeIsBidding },
                                model: {
                                  value:
                                    _vm.formData.project_evaluation.is_bidding,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.project_evaluation,
                                      "is_bidding",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.project_evaluation.is_bidding",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("投标"),
                                ]),
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("非招投标（项目询价、调研等）"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.formData.project_evaluation.is_bidding === "1"
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "报名公司主体",
                                  prop: "project_evaluation.registration_company_entity",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    readonly:
                                      _vm.isViewTaskDisabled("projectInfo"),
                                    maxlength: 50,
                                    placeholder: "请输入报名公司主体",
                                  },
                                  model: {
                                    value:
                                      _vm.formData.project_evaluation
                                        .registration_company_entity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.project_evaluation,
                                        "registration_company_entity",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n\t\t\t\t\t\t\t\tformData.project_evaluation.registration_company_entity\n\t\t\t\t\t\t\t",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.project_evaluation.is_bidding === "1"
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "是否需要写标书",
                                  prop: "project_evaluation.need_bid_writing",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.changeNeedBidWriting },
                                    model: {
                                      value:
                                        _vm.formData.project_evaluation
                                          .need_bid_writing,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.project_evaluation,
                                          "need_bid_writing",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.project_evaluation.need_bid_writing",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("是"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("否"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.project_evaluation.is_bidding === "1" &&
                    _vm.formData.project_evaluation.need_bid_writing === "2"
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "是否希望和投标部合作",
                                  prop: "project_evaluation.want_cooperate_bid_dept",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value:
                                        _vm.formData.project_evaluation
                                          .want_cooperate_bid_dept,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.project_evaluation,
                                          "want_cooperate_bid_dept",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.project_evaluation.want_cooperate_bid_dept",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("是"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("否"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否成交客户" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: "" },
                                model: {
                                  value:
                                    _vm.formData.project_evaluation
                                      .is_deal_customer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.project_evaluation,
                                      "is_deal_customer",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.project_evaluation.is_deal_customer",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "2" } }, [
                                  _vm._v("是"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("否"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "项目文件",
                              prop: "project_evaluation.project_files",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "500px" } },
                              [
                                _c("uploadFile", {
                                  ref: "projectFileUpload",
                                  attrs: {
                                    "file-list":
                                      _vm.formData.project_evaluation
                                        .project_files,
                                    limit: 9,
                                    multiple: true,
                                    "current-file-count":
                                      _vm.formData.project_evaluation
                                        .project_files.length,
                                    disabled:
                                      _vm.isViewTaskDisabled("projectInfo"),
                                    source: "file",
                                    "link-url": {
                                      config:
                                        "/user/project-delivery-file/upload/config",
                                      extensions:
                                        "/user/project-delivery-file/upload/file-allow-extensions",
                                    },
                                    "only-img": false,
                                  },
                                  on: {
                                    emitUploadFile:
                                      _vm.handleProjectFileUploaded,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm.formData.project_evaluation.project_files.length
                              ? _c(
                                  "div",
                                  { staticClass: "file-list" },
                                  _vm._l(
                                    _vm.formData.project_evaluation
                                      .project_files,
                                    function (item, idx) {
                                      return _c(
                                        "div",
                                        { key: idx, staticClass: "file-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "file-name",
                                              class: {
                                                "pdf-file": _vm.isPdfFile(item),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.isPdfFile(item) &&
                                                    _vm.openPdfFile(item)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(item.file_name))]
                                          ),
                                          !_vm.isViewTaskDisabled("projectInfo")
                                            ? _c("el-button", {
                                                staticClass:
                                                  "project-info-action",
                                                attrs: {
                                                  type: "text",
                                                  icon: "el-icon-delete",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteProjectFile(
                                                      idx
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _c("el-button", {
                                            attrs: {
                                              type: "text",
                                              icon: "el-icon-download",
                                              disabled: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downProjectFile(
                                                  item.url,
                                                  item.file_name
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.formData.project_evaluation.is_bidding === "1"
                  ? [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "采购内容",
                                    prop: "project_evaluation.purchase_content",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value:
                                          _vm.formData.project_evaluation
                                            .purchase_content,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.project_evaluation,
                                            "purchase_content",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.project_evaluation.purchase_content",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "1" } },
                                        [_vm._v("礼包")]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "2" } },
                                        [_vm._v("商城")]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "3" } },
                                        [_vm._v("线下商超")]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "4" } },
                                        [_vm._v("生日")]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "5" } },
                                        [_vm._v("电影")]
                                      ),
                                      _c(
                                        "el-checkbox",
                                        { attrs: { label: "6" } },
                                        [_vm._v("第三方功能")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "历史成交竞品信息" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      readonly:
                                        _vm.isViewTaskDisabled("projectInfo"),
                                      rows: 4,
                                      placeholder: "请输入",
                                      maxlength: 2000,
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value:
                                        _vm.formData.project_evaluation
                                          .history_competitor_info,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.project_evaluation,
                                          "history_competitor_info",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.project_evaluation.history_competitor_info",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "历史折扣信息" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      readonly:
                                        _vm.isViewTaskDisabled("projectInfo"),
                                      rows: 4,
                                      placeholder: "请输入",
                                      maxlength: 2000,
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value:
                                        _vm.formData.project_evaluation
                                          .history_discount_info,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.project_evaluation,
                                          "history_discount_info",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.project_evaluation.history_discount_info",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "历史交付形式" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      readonly:
                                        _vm.isViewTaskDisabled("projectInfo"),
                                      rows: 4,
                                      placeholder: "请输入",
                                      maxlength: 2000,
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value:
                                        _vm.formData.project_evaluation
                                          .history_delivery_form,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.project_evaluation,
                                          "history_delivery_form",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.project_evaluation.history_delivery_form",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.showProjectLeader()
                  ? _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "项目负责人",
                                  prop: "person_charge_id",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "请选择项目负责人",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handlePersonChargeChange(
                                          _vm.formData,
                                          _vm.leaderOptions
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.formData.person_charge_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "person_charge_id",
                                          $$v
                                        )
                                      },
                                      expression: "formData.person_charge_id",
                                    },
                                  },
                                  _vm._l(_vm.leaderOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
            (_vm.formData.project_meeting &&
              _vm.formData.project_meeting.process_result) ||
            _vm.type == "projectReview"
              ? _c(
                  "div",
                  [
                    _vm.$hasBtnRoles("/user/project-delivery/project-info")
                      ? _c("div", { staticClass: "small-form-title" }, [
                          _vm._v(" 项目待过会信息 "),
                        ])
                      : _vm._e(),
                    _vm.$hasBtnRoles("/user/project-delivery/project-info")
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "处理结果",
                                      prop: "project_meeting.process_result",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.isProjectInfoFieldDisabled(
                                              "process_result"
                                            ),
                                        },
                                        on: { change: _vm.changeProcessResult },
                                        model: {
                                          value:
                                            _vm.formData.project_meeting
                                              .process_result,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.project_meeting,
                                              "process_result",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.project_meeting.process_result",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v("项目立项通过")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "2" } },
                                          [_vm._v("项目立项失败")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "3" } },
                                          [_vm._v("弃标")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.project_meeting.process_result === "3" &&
                    _vm.$hasBtnRoles("/user/project-delivery/project-info")
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "弃标原因",
                                      prop: "project_meeting.abandon_reason",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        readonly:
                                          _vm.isViewTaskDisabled("projectInfo"),
                                        rows: 4,
                                        placeholder: "请输入弃标原因",
                                        maxlength: 2000,
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value:
                                          _vm.formData.project_meeting
                                            .abandon_reason,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.project_meeting,
                                            "abandon_reason",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.project_meeting.abandon_reason",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.formData.project_meeting.process_result === "1"
                      ? [
                          _vm.$hasBtnRoles(
                            "/user/project-delivery/project-info"
                          )
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "10px",
                                          },
                                          attrs: { label: "任务" },
                                        },
                                        [
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              model: {
                                                value: _vm.formData.type,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "type",
                                                    $$v
                                                  )
                                                },
                                                expression: "formData.type",
                                              },
                                            },
                                            [
                                              _vm.shouldShowTaskType("1")
                                                ? _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "1",
                                                        disabled:
                                                          _vm.isProjectInfoTaskDisabled(
                                                            "1"
                                                          ),
                                                      },
                                                    },
                                                    [_vm._v("商城装修")]
                                                  )
                                                : _vm._e(),
                                              _vm.shouldShowTaskType("2")
                                                ? _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "2",
                                                        disabled:
                                                          _vm.formData
                                                            .project_evaluation
                                                            .is_bidding ===
                                                            "1" ||
                                                          _vm.isProjectInfoTaskDisabled(
                                                            "2"
                                                          ),
                                                      },
                                                    },
                                                    [_vm._v("投标支持")]
                                                  )
                                                : _vm._e(),
                                              _vm.shouldShowTaskType("3")
                                                ? _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "3",
                                                        disabled:
                                                          _vm.isProjectInfoTaskDisabled(
                                                            "3"
                                                          ),
                                                      },
                                                    },
                                                    [_vm._v("定制设计及印刷")]
                                                  )
                                                : _vm._e(),
                                              _vm.shouldShowTaskType("9")
                                                ? _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "9",
                                                        disabled:
                                                          _vm.quotationCheckboxDisabled ||
                                                          _vm.isProjectInfoTaskDisabled(
                                                            "9"
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.quotationCheckboxLabel
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "客情系数",
                                            prop: "project_meeting.customer_relationship",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请选择",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .customer_relationship,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "customer_relationship",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.customer_relationship",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "S级（历史成交）",
                                                  value: "S",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label:
                                                    "A级（多次拜访未成交）",
                                                  value: "A",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label:
                                                    "B级（首拜介绍过方案）",
                                                  value: "B",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "C级（电联未拜访）",
                                                  value: "C",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "D级（0客情盲投）",
                                                  value: "D",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "采购人数",
                                            prop: "project_meeting.purchase_count",
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              min: 1,
                                              "controls-position": "right",
                                              placeholder: "请输入",
                                            },
                                            on: {
                                              input: _vm.calcPurchaseAmount,
                                            },
                                            model: {
                                              value:
                                                _vm.formData.project_meeting
                                                  .purchase_count,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData.project_meeting,
                                                  "purchase_count",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.project_meeting.purchase_count",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "单人预算",
                                            prop: "project_meeting.per_capita_budget",
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              min: 1,
                                              "controls-position": "right",
                                              placeholder: "请输入",
                                            },
                                            on: {
                                              input: _vm.calcPurchaseAmount,
                                            },
                                            model: {
                                              value:
                                                _vm.formData.project_meeting
                                                  .per_capita_budget,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData.project_meeting,
                                                  "per_capita_budget",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.project_meeting.per_capita_budget",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "采购金额" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.type !== "view",
                                              readonly:
                                                _vm.type === "view" &&
                                                !_vm.isEditingTask(
                                                  "projectInfo"
                                                ),
                                              placeholder: "自动计算",
                                            },
                                            model: {
                                              value:
                                                _vm.formData.project_meeting
                                                  .purchase_amount,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData.project_meeting,
                                                  "purchase_amount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.project_meeting.purchase_amount",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.formData.project_evaluation.is_bidding ===
                                  "1"
                                    ? [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "开标方式",
                                                  prop: "project_meeting.bid_opening_method",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.formData
                                                          .project_meeting
                                                          .bid_opening_method,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formData
                                                            .project_meeting,
                                                          "bid_opening_method",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formData.project_meeting.bid_opening_method",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: "1" } },
                                                      [_vm._v("电子开标")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: "2" } },
                                                      [_vm._v("线下开标")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "标书寄出/上传时间",
                                                  prop: "project_meeting.bid_send_time",
                                                },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    readonly:
                                                      _vm.isViewTaskDisabled(
                                                        "projectInfo"
                                                      ),
                                                    type: "date",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData
                                                        .project_meeting
                                                        .bid_send_time,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData
                                                          .project_meeting,
                                                        "bid_send_time",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.project_meeting.bid_send_time",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "开标/比选时间",
                                            prop: "project_meeting.bid_opening_time",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              readonly:
                                                _vm.isViewTaskDisabled(
                                                  "projectInfo"
                                                ),
                                              type: "date",
                                              "value-format": "yyyy-MM-dd",
                                              placeholder: "请选择",
                                            },
                                            model: {
                                              value:
                                                _vm.formData.project_meeting
                                                  .bid_opening_time,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData.project_meeting,
                                                  "bid_opening_time",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.project_meeting.bid_opening_time",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "是否需要样品",
                                            prop: "project_meeting.need_sample",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              on: {
                                                change: _vm.changeNeedSample,
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .need_sample,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "need_sample",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.need_sample",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "2" } },
                                                [_vm._v("是")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "1" } },
                                                [_vm._v("否")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.formData.project_meeting.need_sample ===
                                  "2"
                                    ? _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "样品最晚寄出时间",
                                                prop: "project_meeting.sample_deadline",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  readonly:
                                                    _vm.isViewTaskDisabled(
                                                      "projectInfo"
                                                    ),
                                                  type: "date",
                                                  "value-format": "yyyy-MM-dd",
                                                  placeholder: "请选择",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.project_meeting
                                                      .sample_deadline,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData
                                                        .project_meeting,
                                                      "sample_deadline",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.project_meeting.sample_deadline",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "是否演示",
                                            prop: "project_meeting.demo_type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .demo_type,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "demo_type",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.demo_type",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "1" } },
                                                [_vm._v("无需演示")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "2" } },
                                                [_vm._v("线上演示")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "3" } },
                                                [_vm._v("线下演示")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "报价形式",
                                            prop: "project_meeting.quotation_type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请选择",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .quotation_type,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "quotation_type",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.quotation_type",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "折扣率",
                                                  value: "1",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "上浮率",
                                                  value: "2",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "总价报价",
                                                  value: "3",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "单价报价",
                                                  value: "4",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "无需报价",
                                                  value: "5",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "其他",
                                                  value: "6",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "结算方式",
                                            prop: "project_meeting.settlement_method",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .settlement_method,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "settlement_method",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.settlement_method",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "1" } },
                                                [_vm._v("发卡结算")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "2" } },
                                                [_vm._v("消费据实结算")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "是否汇报",
                                            prop: "project_meeting.report_type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .report_type,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "report_type",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.report_type",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "1" } },
                                                [_vm._v("无需汇报")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "2" } },
                                                [_vm._v("线上PPT讲解")]
                                              ),
                                              _c(
                                                "el-radio",
                                                { attrs: { label: "3" } },
                                                [_vm._v("线下PPT讲解")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.$hasBtnRoles(
                            "/user/project-delivery/project-info"
                          )
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "会议纪要" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              readonly:
                                                _vm.isViewTaskDisabled(
                                                  "projectInfo"
                                                ),
                                              rows: 4,
                                              placeholder: "请输入",
                                              maxlength: 2000,
                                              "show-word-limit": "",
                                            },
                                            model: {
                                              value:
                                                _vm.formData.project_meeting
                                                  .meeting_minutes,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData.project_meeting,
                                                  "meeting_minutes",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.project_meeting.meeting_minutes",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$hasBtnRoles(
                            "/user/project-delivery/project-info"
                          )
                            ? _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "会议纪要附件",
                                            prop: "project_meeting.meeting_minutes_file",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "design-draft-upload meeting-minutes-upload",
                                            },
                                            [
                                              !_vm.isViewTaskDisabled(
                                                "projectInfo"
                                              )
                                                ? [
                                                    _c(
                                                      "span",
                                                      {
                                                        on: {
                                                          paste:
                                                            _vm.handleMeetingMinutesPaste,
                                                        },
                                                      },
                                                      [
                                                        _c("input", {
                                                          staticClass:
                                                            "pasteInput",
                                                          attrs: {
                                                            type: "text",
                                                            placeholder:
                                                              "粘贴截图上传",
                                                            maxlength: "0",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "el-icon-upload importFile",
                                                        attrs: {
                                                          type: "primary",
                                                          disabled:
                                                            _vm.formData
                                                              .project_meeting
                                                              .meeting_minutes_file
                                                              .length >= 9,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.uploadMeetingMinutesFile,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "上传文件 (" +
                                                            _vm._s(
                                                              _vm.formData
                                                                .project_meeting
                                                                .meeting_minutes_file
                                                                .length
                                                            ) +
                                                            "/9)"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "upload-tip",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 最多支持上传9个文件，单个文件不超过300M "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm.formData.project_meeting
                                                .meeting_minutes_file.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "file-list",
                                                    },
                                                    _vm._l(
                                                      _vm.formData
                                                        .project_meeting
                                                        .meeting_minutes_file,
                                                      function (item, idx) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: idx,
                                                            staticClass:
                                                              "file-item",
                                                          },
                                                          [
                                                            _vm.isImageFile(
                                                              item
                                                            )
                                                              ? _c("el-image", {
                                                                  staticStyle: {
                                                                    width:
                                                                      "120px",
                                                                    height:
                                                                      "80px",
                                                                    "flex-shrink":
                                                                      "0",
                                                                    border:
                                                                      "1px solid #ebeef5",
                                                                    "border-radius":
                                                                      "4px",
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      _vm.$ossurl +
                                                                      item.url,
                                                                    fit: "contain",
                                                                    "preview-src-list":
                                                                      _vm.meetingMinutesImageSrcList,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "file-name",
                                                                class: {
                                                                  "pdf-file":
                                                                    _vm.isPdfFile(
                                                                      item
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.isPdfFile(
                                                                        item
                                                                      ) &&
                                                                        _vm.openPdfFile(
                                                                          item
                                                                        )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.file_name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            !_vm.isViewTaskDisabled(
                                                              "projectInfo"
                                                            )
                                                              ? _c(
                                                                  "el-button",
                                                                  {
                                                                    staticClass:
                                                                      "project-info-action",
                                                                    attrs: {
                                                                      type: "text",
                                                                      icon: "el-icon-delete",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteMeetingMinutesFile(
                                                                            idx
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c("el-button", {
                                                              attrs: {
                                                                type: "text",
                                                                icon: "el-icon-download",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.downProjectFile(
                                                                      item.url,
                                                                      item.file_name
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                              _c("uploadFile", {
                                                ref: "meetingMinutesUpload",
                                                staticStyle: {
                                                  display: "none",
                                                },
                                                attrs: {
                                                  "only-img": false,
                                                  "link-url": {
                                                    config:
                                                      "/user/project-delivery-file/upload/config",
                                                    extensions:
                                                      "/user/project-delivery-file/upload/file-allow-extensions",
                                                  },
                                                  "upload-info": {
                                                    file_allow_extensions: [],
                                                    file_size_limit: 307200,
                                                  },
                                                  source: "file",
                                                  "current-file-count":
                                                    _vm.formData.project_meeting
                                                      .meeting_minutes_file
                                                      .length,
                                                  limit: 9,
                                                  multiple: true,
                                                },
                                                on: {
                                                  emitUploadFile:
                                                    _vm.handleMeetingMinutesFileUploaded,
                                                },
                                              }),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.$hasBtnRoles("/user/project-delivery/sensitive")
                            ? [
                                _c("div", { staticClass: "small-form-title" }, [
                                  _vm._v("敏感信息"),
                                ]),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "应标策略资源",
                                              prop: "project_meeting.bid_strategy_resources",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                readonly:
                                                  _vm.isViewTaskDisabled(
                                                    "projectInfo"
                                                  ),
                                                rows: 4,
                                                placeholder: "请输入",
                                                maxlength: 2000,
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .bid_strategy_resources,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "bid_strategy_resources",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.bid_strategy_resources",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "历史订单总结" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                readonly:
                                                  _vm.isViewTaskDisabled(
                                                    "projectInfo"
                                                  ),
                                                rows: 4,
                                                placeholder: "请输入",
                                                maxlength: 2000,
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.project_meeting
                                                    .history_order_director,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData
                                                      .project_meeting,
                                                    "history_order_director",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.project_meeting.history_order_director",
                                              },
                                            }),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass:
                                                  "project-info-action",
                                                attrs: { type: "text" },
                                                on: {
                                                  click:
                                                    _vm.handleViewHistoryOrder,
                                                },
                                              },
                                              [_vm._v("查看历史订单")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm.showProjectInfoEditButton("projectInfo")
              ? _c("section-edit-actions", {
                  attrs: {
                    editing: _vm.isEditingTask("projectInfo"),
                    loading: _vm.editSaving,
                  },
                  on: {
                    start: function ($event) {
                      return _vm.startProjectInfoEdit("projectInfo")
                    },
                    confirm: _vm.confirmProjectInfoEdit,
                    cancel: _vm.cancelProjectInfoEdit,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm.formData.project_meeting &&
    _vm.formData.project_meeting.process_result === "1"
      ? _c(
          "div",
          {
            staticClass: "sub-form-container",
            class: { "sub-form-editing": _vm.isEditingTask("supplier") },
          },
          [
            _c("div", { staticClass: "sub-form-title" }, [
              _vm._v("历史供应商信息"),
            ]),
            _vm._l(
              _vm.formData.project_meeting.other_suppliers,
              function (supplier, sIndex) {
                return _c(
                  "div",
                  { key: sIndex },
                  [
                    sIndex > 0 ? _c("el-divider") : _vm._e(),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "成交日期" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    readonly:
                                      _vm.isViewTaskDisabled("supplier"),
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: supplier.deal_date,
                                    callback: function ($$v) {
                                      _vm.$set(supplier, "deal_date", $$v)
                                    },
                                    expression: "supplier.deal_date",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "成交供应商" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isViewTaskDisabled("supplier"),
                                      remote: "",
                                      filterable: "",
                                      clearable: "",
                                      "remote-method": function (keyword) {
                                        return _vm.searchSupplierOptions(
                                          keyword,
                                          supplier
                                        )
                                      },
                                      placeholder: "请输入供应商名称",
                                    },
                                    on: {
                                      change: function (id) {
                                        return _vm.changeSupplierOption(
                                          supplier,
                                          id
                                        )
                                      },
                                      "visible-change": function (visible) {
                                        return _vm.handleSupplierVisible(
                                          visible,
                                          supplier
                                        )
                                      },
                                    },
                                    model: {
                                      value: supplier.customer_id,
                                      callback: function ($$v) {
                                        _vm.$set(supplier, "customer_id", $$v)
                                      },
                                      expression: "supplier.customer_id",
                                    },
                                  },
                                  _vm._l(
                                    supplier.options || [],
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.company_name,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                !supplier.customer_id && supplier.company_name
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "deal-supplier-unmatched",
                                      },
                                      [
                                        _vm._v(
                                          " 未匹配到供应商，请修改。旧数据：" +
                                            _vm._s(supplier.company_name) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "成交折扣" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    readonly:
                                      _vm.isViewTaskDisabled("supplier"),
                                    maxlength: 100,
                                    placeholder: "请输入",
                                  },
                                  model: {
                                    value: supplier.deal_discount,
                                    callback: function ($$v) {
                                      _vm.$set(supplier, "deal_discount", $$v)
                                    },
                                    expression: "supplier.deal_discount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "交付形式" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    readonly:
                                      _vm.isViewTaskDisabled("supplier"),
                                    maxlength: 100,
                                    placeholder: "请输入",
                                  },
                                  model: {
                                    value: supplier.delivery_form,
                                    callback: function ($$v) {
                                      _vm.$set(supplier, "delivery_form", $$v)
                                    },
                                    expression: "supplier.delivery_form",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "交付痛点" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    readonly:
                                      _vm.isViewTaskDisabled("supplier"),
                                    rows: 4,
                                    placeholder: "请输入",
                                    maxlength: 2000,
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value: supplier.delivery_pain_point,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        supplier,
                                        "delivery_pain_point",
                                        $$v
                                      )
                                    },
                                    expression: "supplier.delivery_pain_point",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "" } },
                      [
                        (_vm.type !== "view" ||
                          _vm.isEditingTask("supplier")) &&
                        sIndex ===
                          _vm.formData.project_meeting.other_suppliers.length -
                            1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "project-info-action",
                                attrs: { type: "text", icon: "el-icon-plus" },
                                on: { click: _vm.addOtherSupplier },
                              },
                              [_vm._v("添加供应商信息")]
                            )
                          : _vm._e(),
                        (_vm.type !== "view" ||
                          _vm.isEditingTask("supplier")) &&
                        _vm.formData.project_meeting.other_suppliers.length > 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "project-info-action",
                                staticStyle: { "margin-left": "8px" },
                                attrs: { type: "text", icon: "el-icon-delete" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeOtherSupplier(sIndex)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }
            ),
            _vm.showProjectInfoEditButton("supplier")
              ? _c("section-edit-actions", {
                  attrs: {
                    editing: _vm.isEditingTask("supplier"),
                    loading: _vm.editSaving,
                  },
                  on: {
                    start: function ($event) {
                      return _vm.startProjectInfoEdit("supplier")
                    },
                    confirm: _vm.confirmProjectInfoEdit,
                    cancel: _vm.cancelProjectInfoEdit,
                  },
                })
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm.formData.project_meeting &&
    _vm.formData.project_meeting.process_result === "1"
      ? _c(
          "div",
          {
            staticClass: "sub-form-container",
            class: { "sub-form-editing": _vm.isEditingTask("quotation") },
          },
          [
            _c("div", { staticClass: "sub-form-title" }, [_vm._v("报价单")]),
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "报价单" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            readonly: _vm.isViewTaskDisabled("quotation"),
                            rows: 4,
                            placeholder: "请输入",
                            maxlength: 2000,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.formData.project_meeting.quotation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.project_meeting,
                                "quotation",
                                $$v
                              )
                            },
                            expression: "formData.project_meeting.quotation",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.showProjectInfoEditButton("quotation")
              ? _c("section-edit-actions", {
                  attrs: {
                    editing: _vm.isEditingTask("quotation"),
                    loading: _vm.editSaving,
                  },
                  on: {
                    start: function ($event) {
                      return _vm.startProjectInfoEdit("quotation")
                    },
                    confirm: _vm.confirmProjectInfoEdit,
                    cancel: _vm.cancelProjectInfoEdit,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }